module.exports = __webpack_public_path__ + "img/maintenance-bg.49ae8bf9.png";